import React, { createContext, useContext } from 'react';
import { useGradeGate } from '../hooks/useGradeGate';
import { GateStatus } from '../types/gate';

interface GradeGateContextValue {
  isGated: boolean;
  submittedCount: number;
  requiredCount: number;
  loading: boolean;
  status: GateStatus;
  error: string | null;
  retry: () => Promise<void>;
  setExempt: () => Promise<void>;
  notifyGradeSubmitted: () => void;
  currentSemester: { academicYear: string; semester: string };
}

const GradeGateContext = createContext<GradeGateContextValue | null>(null);

export const GradeGateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const gate = useGradeGate();
  return (
    <GradeGateContext.Provider value={gate}>
      {children}
    </GradeGateContext.Provider>
  );
};

export const useGradeGateContext = (): GradeGateContextValue => {
  const context = useContext(GradeGateContext);
  if (!context) {
    throw new Error('useGradeGateContext must be used within a GradeGateProvider');
  }
  return context;
};
